import { render, staticRenderFns } from "./ImageViewMultipleChoice.vue?vue&type=template&id=d0e5eb88&scoped=true"
import script from "./ImageViewMultipleChoice.vue?vue&type=script&lang=js"
export * from "./ImageViewMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./ImageViewMultipleChoice.vue?vue&type=style&index=0&id=d0e5eb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e5eb88",
  null
  
)

export default component.exports